import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Spinner from "../components/Spinner/Spinner";

import UpcomingEvents from "../components/Dashboard/UpcomingEvents";
import version from "../version.json";
import UpcomingRides from "../components/Dashboard/UpcomingRides";
import AnalyticsSummary from "../components/Dashboard/AnalyticsSummary";
import PendingJoinRequests from "../components/Group/PendingJoinRequests";

const Home = () => {
  // State to hold the user data
  const [user, setUser] = useState(null);

  const [isNewVersion, setIsNewVersion] = useState(false);

  useEffect(() => {
    // Fetch the user info from localStorage when the component mounts
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      setUser(JSON.parse(userInfo));
    }

    // Version check
    const storedVersion = localStorage.getItem("appVersion");
    const currentVersion = version.version;

    if (storedVersion && storedVersion !== currentVersion) {
      setIsNewVersion(true);
      localStorage.setItem("appVersion", currentVersion);
    } else if (!storedVersion) {
      localStorage.setItem("appVersion", currentVersion);
    }
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//code.tidio.co/zpl1twxpf7tejzunui2f2tor4y8641ci.js";
    script.async = true;
    document.body.appendChild(script);

    // Optional: Clean up the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []); // The empty array ensures the effect runs only once after the initial render

  if (!user) {
    return <Spinner />;
  }

  return (
    user && (
      <div className="min-h-screen bg-gray-100 px-4 py-6">
        {/* Version Update Alert */}
        {isNewVersion && (
          <div className="mx-auto mb-4 max-w-7xl rounded-lg border border-yellow-200 bg-yellow-50 p-4 text-[#004a7e] shadow-sm">
            <strong>New Version Available:</strong> A new version of the app is
            available.{" "}
            <a href="/version-history" className="underline">
              See what's changed
            </a>
          </div>
        )}
        {/* Welcome Banner */}
        <div className="mx-auto max-w-7xl rounded-xl bg-gradient-to-br from-[#004a7e] to-[#0b669d] p-5 text-white shadow-xl sm:p-7">
          <div className="gap-5 sm:flex sm:items-end sm:justify-between">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/70">
                Admin dashboard
              </p>
              <h1 className="mt-2 text-2xl font-black md:text-4xl">
                Welcome, {user.name}!
              </h1>
              <p className="mt-2 max-w-2xl text-sm text-white/80">
                Quickly review upcoming activity, active rides, and jump into
                the tools you use most.
              </p>
            </div>
            <div className="mt-5 grid grid-cols-2 gap-2 sm:mt-0 sm:flex">
              <Link
                to="/event/create"
                className="rounded-lg bg-white px-4 py-3 text-center text-sm font-bold text-[#004a7e] shadow-md"
              >
                Create Event
              </Link>
              <Link
                to="/events"
                className="rounded-lg bg-white/15 px-4 py-3 text-center text-sm font-bold text-white ring-1 ring-white/25"
              >
                View Events
              </Link>
            </div>
          </div>
        </div>

        {/* Upcoming Events */}
        <section className="mx-auto mt-6 max-w-7xl">
          <PendingJoinRequests compact />
        </section>

        <section className="mx-auto mt-6 max-w-7xl">
          <UpcomingEvents />
        </section>

        {/* Upcoming Rides */}
        <section className="mx-auto mt-6 max-w-7xl">
          <UpcomingRides />
        </section>

        {/* Analytics */}
        <section className="mx-auto mt-6 max-w-7xl">
          <AnalyticsSummary compact />
        </section>
      </div>
    )
  );
};

export default Home;
